// Loaded by every MCQ unit snippet; the guard stops a second load from re-declaring the class.
if (!window.__mcqInteractiveLoaded) {
window.__mcqInteractiveLoaded = true;

class MCQBlock {
  constructor(block) {
    this.block = block;
    this.correct = block.dataset.mcqCorrect;
    this.opts = Array.from(block.querySelectorAll('.mcq-opt'));
    this.footer = block.querySelector('.mcq-footer');
    this.resultEl = this.footer ? this.footer.querySelector('.mcq-result') : null;
    this.retryBtn = this.footer ? this.footer.querySelector('.mcq-retry') : null;
    this.locked = false;

    if (!this.correct || this.opts.length === 0) return;

    this.opts.forEach((opt) => {
      opt.addEventListener('click', () => this.handlePick(opt));
    });

    if (this.retryBtn) {
      this.retryBtn.addEventListener('click', () => this.reset());
    }
  }

  handlePick(opt) {
    if (this.locked) return;
    this.locked = true;

    const picked = opt.dataset.letter;

    this.opts.forEach((o) => {
      o.disabled = true;
      if (o.dataset.letter === this.correct) {
        o.classList.add('mcq-correct');
      } else if (o.dataset.letter === picked) {
        o.classList.add('mcq-incorrect');
      }
    });

    if (this.resultEl) {
      const isRight = picked === this.correct;
      this.resultEl.textContent = isRight ? 'Correct!' : `Not quite — correct answer is ${this.correct}`;
      this.resultEl.className = 'mcq-result ' + (isRight ? 'mcq-right' : 'mcq-wrong');
    }
    if (this.footer) this.footer.classList.add('mcq-show');
  }

  reset() {
    this.locked = false;
    this.opts.forEach((o) => {
      o.disabled = false;
      o.classList.remove('mcq-correct', 'mcq-incorrect');
    });
    if (this.footer) this.footer.classList.remove('mcq-show');
  }
}

const initMCQBlocks = () => {
  document.querySelectorAll('.question-block[data-mcq-correct]').forEach((block) => {
    new MCQBlock(block);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMCQBlocks);
} else {
  initMCQBlocks();
}

}
